import React, { useState } from 'react';
import { supabase } from './supabaseClient'; 

const AuthGate = ({ onBack }) => {
  const [view, setView] = useState('login'); 
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  // Tema Renkleri
  const ACCENT_RED = '#8b3a3a'; 
  const ACCENT_RED_HOVER = '#5a0d0e';
  const JERUSALEM_GOLD = '#c5a059';
  const VINTAGE_BEIGE = '#e5d1a5';

  const handleAuth = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMsg('');
    setSuccessMsg('');

    try {
      if (view === 'login') {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
      } else if (view === 'signup') {
        const { error } = await supabase.auth.signUp({ email, password });
        if (error) throw error;
        else setSuccessMsg('Check your email for the confirmation seal.');
      } else if (view === 'reset') {
        const { error } = await supabase.auth.resetPasswordForEmail(email);
        if (error) throw error;
        else setSuccessMsg('Password reset instructions sent to your email.');
      }
    } catch (err) {
      setErrorMsg(err.message || 'An error occurred during authentication.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#1a0f0a', 
      backgroundImage: 'radial-gradient(circle at center, #2c1810 0%, #0d0805 100%)', 
      fontFamily: 'Courier Prime, monospace'
    }}>
      
      {/* KASA KUTUSU */}
      <div style={{
        maxWidth: '400px', 
        width: '90%', 
        padding: '45px 40px',
        position: 'relative',
        backgroundColor: '#110c09', 
        border: `1px solid rgba(197, 160, 89, 0.2)`, 
        borderTop: `3px solid ${ACCENT_RED}`, 
        boxShadow: '0 15px 40px rgba(0,0,0,0.8)',
        borderRadius: '3px',
      }}>
        
        {/* GERİ DÖN BUTONU */}
        <button 
          onClick={onBack}
          style={{
            position: 'absolute', top: '20px', left: '20px',
            background: 'none', border: 'none', color: '#8e8579', 
            fontFamily: 'Courier Prime, monospace', cursor: 'pointer',
            fontSize: '1.2rem', transition: 'all 0.3s'
          }}
          onMouseOver={e => { e.currentTarget.style.color = JERUSALEM_GOLD; e.currentTarget.style.transform = 'translateX(-3px)'; }}
          onMouseOut={e => { e.currentTarget.style.color = '#8e8579'; e.currentTarget.style.transform = 'translateX(0)'; }}
          title="Return to Sanctuary"
        >
          ←
        </button>

        {/* BAŞLIK */}
        <h2 style={{
          fontFamily: 'Cinzel, serif', color: JERUSALEM_GOLD, textAlign: 'center',
          fontSize: '1.6rem', letterSpacing: '3px', marginBottom: '15px', marginTop: '10px',
          textTransform: 'uppercase', fontWeight: 'bold'
        }}>
          {view === 'login' ? "Sign In" : view === 'signup' ? "Initiation" : "Recover Key"}
        </h2>
        
        <div style={{ width: '40px', height: '1px', backgroundColor: 'rgba(197, 160, 89, 0.4)', margin: '0 auto 35px' }}></div>

        {/* FORM */}
        <form onSubmit={handleAuth} style={{ display: 'flex', flexDirection: 'column', gap: '22px' }}>
          
          <div>
            <input 
              type="email" 
              placeholder="Email Address"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              style={{
                width: '100%', backgroundColor: 'rgba(0,0,0,0.4)', color: VINTAGE_BEIGE, 
                border: '1px solid rgba(197, 160, 89, 0.2)', padding: '12px 16px', // Inputları da azıcık incelttim
                borderRadius: '2px', outline: 'none', transition: 'all 0.3s',
                fontFamily: 'Courier Prime, monospace', fontSize: '0.9rem'
              }}
              onFocus={(e) => { e.currentTarget.style.borderColor = JERUSALEM_GOLD; e.currentTarget.style.boxShadow = '0 0 10px rgba(197, 160, 89, 0.1)'; }}
              onBlur={(e) => { e.currentTarget.style.borderColor = 'rgba(197, 160, 89, 0.2)'; e.currentTarget.style.boxShadow = 'none'; }}
            />
          </div>

          {view !== 'reset' && (
            <div>
              <input 
                type="password" 
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{
                    width: '100%', backgroundColor: 'rgba(0,0,0,0.4)', color: VINTAGE_BEIGE, 
                    border: '1px solid rgba(197, 160, 89, 0.2)', padding: '12px 16px', // Inputları da azıcık incelttim
                    borderRadius: '2px', outline: 'none', transition: 'all 0.3s',
                    fontFamily: 'Courier Prime, monospace', fontSize: '0.9rem'
                }}
                onFocus={(e) => { e.currentTarget.style.borderColor = JERUSALEM_GOLD; e.currentTarget.style.boxShadow = '0 0 10px rgba(197, 160, 89, 0.1)'; }}
                onBlur={(e) => { e.currentTarget.style.borderColor = 'rgba(197, 160, 89, 0.2)'; e.currentTarget.style.boxShadow = 'none'; }}
              />
            </div>
          )}

          {errorMsg && <p style={{color: '#d48383', fontSize: '0.85rem', textAlign: 'center', margin: 0, padding: '10px', backgroundColor: 'rgba(212, 131, 131, 0.1)', border: '1px solid rgba(212, 131, 131, 0.2)' }}>{errorMsg}</p>}
          {successMsg && <p style={{color: '#83d492', fontSize: '0.85rem', textAlign: 'center', margin: 0, padding: '10px', backgroundColor: 'rgba(131, 212, 146, 0.1)', border: '1px solid rgba(131, 212, 146, 0.2)' }}>{successMsg}</p>}

          {/* İNCELTİLMİŞ ZARİF BUTON */}
          <button 
            type="submit" 
            disabled={loading}
            style={{
                backgroundColor: ACCENT_RED, 
                border: `1px solid ${ACCENT_RED_HOVER}`, 
                color: JERUSALEM_GOLD, 
                padding: '10px', /* Kaba etlilik buradan gidiyor (14px -> 10px) */
                marginTop: '10px',
                cursor: loading ? 'not-allowed' : 'pointer', 
                fontFamily: 'Cinzel, serif', 
                fontWeight: 'bold', 
                fontSize: '0.95rem', /* Font küçüldü */
                letterSpacing: '3px', /* Zarafet için harf arası açıldı */
                transition: 'all 0.2s', 
                borderRadius: '2px',
                textTransform: 'uppercase', 
                boxShadow: '0 4px 10px rgba(0,0,0,0.4)',
                display: 'flex', 
                justifyContent: 'center',
                alignItems: 'center',
                opacity: loading ? 0.7 : 1
            }}
            onMouseOver={(e) => { if(!loading) { e.currentTarget.style.backgroundColor = ACCENT_RED_HOVER; e.currentTarget.style.borderColor = JERUSALEM_GOLD; e.currentTarget.style.transform = 'translateY(-1px)'; } }}
            onMouseOut={(e) => { if(!loading) { e.currentTarget.style.backgroundColor = ACCENT_RED; e.currentTarget.style.borderColor = ACCENT_RED_HOVER; e.currentTarget.style.transform = 'translateY(0)'; } }}
          >
            {loading ? 'Processing...' : (view === 'login' ? 'Sign In' : view === 'signup' ? 'Sign Up' : 'Send Link')}
          </button>
          
        </form>

        {/* ALT LİNKLER */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', textAlign: 'center', marginTop: '30px', paddingTop: '20px', borderTop: '1px dashed rgba(197, 160, 89, 0.2)' }}>
          
          {view === 'login' && (
            <>
              <p style={{ color: '#8e8579', fontSize: '0.85rem', margin: 0 }}>
                A new seeker? 
                <span onClick={() => { setView('signup'); setErrorMsg(''); setSuccessMsg(''); }} style={{ color: JERUSALEM_GOLD, cursor: 'pointer', marginLeft: '8px', fontWeight: 'bold', textDecoration: 'none' }}>Sign up.</span>
              </p>
              <p style={{ margin: 0 }}>
                <span onClick={() => { setView('reset'); setErrorMsg(''); setSuccessMsg(''); }} style={{ color: '#8e8579', fontSize: '0.8rem', cursor: 'pointer', transition: '0.3s' }} onMouseOver={e => e.currentTarget.style.color = JERUSALEM_GOLD} onMouseOut={e => e.currentTarget.style.color = '#8e8579'}>
                  Lost your key?
                </span>
              </p>
            </>
          )}

          {(view === 'signup' || view === 'reset') && (
            <p style={{ margin: 0 }}>
              <span onClick={() => { setView('login'); setErrorMsg(''); setSuccessMsg(''); }} style={{ color: JERUSALEM_GOLD, fontSize: '0.85rem', cursor: 'pointer', fontWeight: 'bold' }}>
                Back to Sign In
              </span>
            </p>
          )}

        </div>

      </div>
    </div>
  );
};

export default AuthGate;